// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** GET MEMBER LOAN INFO START *********************** */
export const fetchDemandLoanList = (listData: any) => {
	const data = {
		FetchDemandForTodayCollectionToken: listData,
	};
	const url = `${API_URL}getDemandForTodayCollections`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER LOAN INFO END *********************** */

/** ***************** UPDATE DEMAND COLLECTION START *********************** */
export const demandCollectionRevertAPI = (listData: any) => {
	const data = {
		RevertDemandForTodayCollectionToken: listData,
	};
	const url = `${API_URL}revertDemandCollection`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE DEMAND COLLECTION END *********************** */

/** ***************** UPDATE THRIFT PAID START *********************** */
export const updateThriftPaidAPI = (listData: any) => {
	const data = {
		UpdateThriftPaidToken: listData,
	};
	const url = `${API_URL}updateThriftPaid`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE THRIFT PAID END *********************** */
